import { render } from "./SlideShowMobile.vue?vue&type=template&id=062a4254&scoped=true"
import script from "./SlideShowMobile.vue?vue&type=script&lang=js"
export * from "./SlideShowMobile.vue?vue&type=script&lang=js"

import "./SlideShowMobile.vue?vue&type=style&index=0&id=062a4254&scoped=true&lang=css"

import exportComponent from "/home/tantonj/Documents/GitHub/TantonSoftwareSolutions/tantonsoftwaresolutions/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062a4254"]])

export default __exports__